<div class="price-container">
  <div class="price">
    <mb-advice [align]="mbAdvicePosition" color="success"
      *ngIf="hotel?.rate?.price?.discount?.amount && hotel?.rate?.price?.discount?.percentage >= 5" class="price__gift">
      {{ hotel.rate.price.discount.percentage }}% OFF
    </mb-advice>
    <ng-container *ngIf="hotel.rate?.isExperts">
      <div class="price__hotel-provider">
        {{ hotel.rate.provider }}
      </div>
    </ng-container>
    <div class="price__amount">
      <ng-container *ngIf="!isAlliance; else alliancePrice">
        <div *ngIf="
              hotel?.rate?.price?.discount?.amount &&
              hotel?.rate?.price?.discount?.percentage >= 5 &&
              (hotel.rate.price.total_without_discount ||
                hotel.rate.price.per_night_per_room_without_discount)
            " class="price__amount__price-without-discount">
          <ng-container *ngIf="currencyCode === 'USD'; else discountInPesos">
            <span>u$s&nbsp;</span>
          </ng-container>
          <ng-template #discountInPesos>
            <span>$&nbsp;</span>
          </ng-template>
          <strong><s>{{
              query?.queryParams?.priceBy === 'TOTAL'
              ? (hotel.rate.price.total_without_discount | Currency)
              : (hotel.rate.price.per_night_per_room_without_discount | Currency)
              }}</s></strong>
        </div>
        <div class="price__amount__price">
          <ng-container *ngIf="query?.queryParams?.priceBy === 'TOTAL'">
            <strong>Precio total</strong>
            <ng-container *ngIf="currencyCode === 'USD'; else totalPriceInPesos">
              <span class="sign">u$s
                <strong>{{ totalPrice | Currency }} </strong>
              </span>
            </ng-container>
            <ng-template #totalPriceInPesos>
              <span class="sign">$
                <strong>{{ totalPrice | Currency }} </strong>
              </span>
            </ng-template>
          </ng-container>
          <ng-container *ngIf="query?.queryParams?.priceBy !== 'TOTAL'">
            <strong>Precio por noche</strong>
            <ng-container *ngIf="currencyCode === 'USD'; else totalPerNightInPesos">
              <span class="sign">u$s
                <strong>{{ totalPerNight | Currency }} </strong>
              </span>
            </ng-container>
            <ng-template #totalPerNightInPesos>
              <span class="sign">$
                <strong>{{ totalPerNight | Currency }} </strong>
              </span>
            </ng-template>
          </ng-container>
        </div>
        <div class="detail-price" [ngClass]="{'endJustify':isMobile}">
          <ng-container *ngTemplateOutlet="taxes"></ng-container>
          <ng-container *ngIf="query?.queryParams?.priceBy === 'TOTAL'">
            <div class="price__secondary_price total-price">
              <span class="price_value">Precio por noche</span>
              <ng-container *ngIf="currencyCode === 'USD'; else secondaryPricePerNightInPesos">
                <span class="price_value">u$s {{ totalPerNight | Currency }} </span>
              </ng-container>
              <ng-template #secondaryPricePerNightInPesos>
                <span class="price_value">$ {{ totalPerNight | Currency }} </span>
              </ng-template>
            </div>
          </ng-container>
          <ng-container *ngIf="!isLanding && query?.queryParams?.priceBy !== 'TOTAL'">
            <div class="price__secondary_price total-price">
              <span class="price_value">Precio total</span>
              <ng-container *ngIf="currencyCode === 'USD'; else secondaryTotalPriceInPesos">
                <span class="price_value">u$s {{ totalPrice | Currency }} </span>
              </ng-container>
              <ng-template #secondaryTotalPriceInPesos>
                <span class="price_value">$ {{ totalPrice | Currency }} </span>
              </ng-template>
            </div>
          </ng-container>
        </div>


      </ng-container>
      <ng-container>
        <div class="pricing-no-tax" [ngClass]="{'mobile-taxes':isMobile}">
          <span>Precio sin impuestos nacionales</span>
          <span>
            {{currencyCode === 'USD'? 'u$s':'$'}}
            {{
            totalWithoutIva | Currency
            }}</span>
        </div>
      </ng-container>
      <ng-template #alliancePrice>
        <am-rewards-pricing [price]="superclubPrice"></am-rewards-pricing>
      </ng-template>
      <ng-container *ngIf="isMobile; else pricingPopMobile">
        <am-pricing-expandable [rateId]="hotel.rate.id" [fop]="paymentMethodText" [currencyCode]="currencyCode"
          #princingExpandable></am-pricing-expandable>
      </ng-container>
      <ng-template #pricingPopMobile>
        <am-pricing-popover [rateId]="hotel.rate.id" [fop]="paymentMethodText" [currencyCode]="currencyCode"
          #pricingPopover>
        </am-pricing-popover>
      </ng-template>

      <div class="price__button_container">
        <button class="--button-fullwidth" mb-button variant="principal" color="primary" (click)="redirectToDetail()">
          Ver alojamiento
        </button>
      </div>
      <div class="payment_method" *ngIf="viewPaymentMethodButton">
        <button mb-button variant="link" color="secondary" (click)="openDialogPaymentMethod()"><mb-icon
            icon="wallet"></mb-icon> Metodos de pago</button>
      </div>
      <!--am-experts-compensation [channel]="'web'" [margin]="commission" [productType]="'HOTEL'" [brand]="context.brand"
        [channel]="context.channel" [language]="context.language" [locale]="context.locale" [site]="context.site"
        [currency]='currencyToCompensation'>
      </!--am-experts-compensation-->
    </div>
  </div>
</div>

<ng-template #taxes>
  <div class="description-taxes" [class.special-taxes]="!isArgentinian && currencyCode == 'ARS'">
    <p>
      <span *ngIf="isArgentinian || (!isArgentinian && currencyCode != 'ARS')">Impuestos incluidos</span>
      <span *ngIf="paymentMethodText === 'PAY_AT_DESTINATION' && !isArgentinian && currencyCode == 'ARS'">Podría
        cobrarse la percepción RG5617</span>
      <span *ngIf="paymentMethodText !== 'PAY_AT_DESTINATION' && !isArgentinian && currencyCode == 'ARS'">No se te
        cobrará la percepción RG5617</span>
      <mb-icon icon="info" class="icon-focus" (click)="isMobile ? expandBreakdown() : showPopover()"></mb-icon>
    </p>
  </div>

</ng-template>